import Home from '~/page/Home';
import Governance from '~/page/Governance';
import Corporate from '~/page/Governance/Corporate';
import Board from '~/page/Governance/Board';
import Documents from '~/page/Governance/Documents';
import News from '~/page/News';
import Releases from '~/page/News/Releases';
import Events from '~/page/News/Events';
import Agm from '~/page/News/Agm';
import Videos from '~/page/News/Videos';
import Detail from '~/page/News/Detail';
import Stock from '~/page/Stock';
import Chart from '~/page/Stock/Chart';
import Analyst from '~/page/Stock/Analyst';
import Financial from '~/page/Financial';
import Quarterly from '~/page/Financial/Quarterly';
import Annual from '~/page/Financial/Annual';
import SEC from '~/page/Financial/SEC';
import Contact from '~/page/Contact';
import IR from '~/page/Contact/IR';
import Investor from '~/page/Contact/Investor';
import Unsubscribe from '~/page/Contact/Unsubscibe';
import FAQ from '~/page/Contact/FAQ';
import VideoDetail from '~/page/News/Videos/VideoDetail';
import Html from '~/page/Html';

export default [
    {
        title: 'Home',
        path: '/',
        name: 'home',
        layout: 'BasicLayout',
        exact: false,
        subRoutes: [
            {
                title: 'Home',
                path: 'home',
                name: 'home',
                exact: true,
                component: Home,
            },
            {
                title: 'Governance',
                path: 'governance',
                name: 'governance',
                // slot 字段设置为 true，表示 subRoutes 里面的组件会渲染在当前组件的指定位置（children属性）
                slot: true,
                exact: false,
                isMainMenu: true,
                component: Governance,
                subRoutes: [
                    {
                        title: 'Corporate Profile',
                        path: 'corporate',
                        name: 'corporate',
                        component: Corporate,
                    },
                    {
                        title: 'Board of Directors',
                        path: 'board',
                        name: 'board',
                        component: Board,
                    },
                    {
                        title: 'Governance Documents',
                        path: 'documents',
                        name: 'documents',
                        component: Documents,
                    },
                    {
                        path: '*',
                        redirect: '/governance/corporate'
                    }
                ]
            },
            {
                title: 'News&Events',
                path: 'news',
                name: 'news',
                slot: true,
                exact: false,
                isMainMenu: true,
                component: News,
                subRoutes: [
                    {
                        title: 'News Releases',
                        path: 'releases',
                        name: 'releases',
                        component: Releases,
                    },
                    {
                        title: 'Events',
                        path: 'events',
                        name: 'events',
                        component: Events,
                    },
                    {
                        title: 'AGM/EGM',
                        path: 'agm',
                        name: 'agm',
                        component: Agm,
                    },
                    {
                        title: 'Videos',
                        path: 'video',
                        name: 'video',
                        component: Videos,
                    },
                    {
                        title: 'Detail',
                        path: 'detail/:id',
                        name: 'detail',
                        component: Detail,
                        exact: true,
                    },
                    {
                        path: '*',
                        redirect: '/news/releases'
                    }
                ]
            },
            {
                title: 'Video Detail',
                path: 'video/detail/:id',
                name: 'video',
                exact: true,
                component: VideoDetail,
            },
            {
                title: 'Stock Infomation',
                path: 'stock',
                name: 'stock',
                slot: true,
                exact: false,
                isMainMenu: true,
                component: Stock,
                subRoutes: [
                    {
                        title: 'Stock Quote & Chart',
                        path: 'chart',
                        name: 'chart',
                        component: Chart,
                    },
                    {
                        title: 'Analyst Coverage',
                        path: 'analyst',
                        name: 'analyst',
                        component: Analyst,
                    },
                    {
                        path: '*',
                        redirect: '/stock/chart'
                    }
                ],
            },
            {
                title: 'Financial Infomation',
                path: 'financial',
                name: 'financial',
                slot: true,
                exact: false,
                isMainMenu: true,
                component: Financial,
                subRoutes: [
                    {
                        title: 'Quarterly Results',
                        path: 'quarterly',
                        name: 'quarterly',
                        component: Quarterly,
                    },
                    {
                        title: 'Annual Reports',
                        path: 'annual',
                        name: 'annual',
                        component: Annual,
                    },
                    {
                        title: 'SEC Filings',
                        path: 'sec',
                        name: 'sec',
                        component: SEC,
                    },
                    {
                        path: '*',
                        redirect: '/financial/quarterly'
                    }
                ]
            },
            {
                title: 'Contact Us',
                path: 'contact',
                name: 'contact',
                slot: true,
                exact: false,
                isMainMenu: true,
                component: Contact,
                subRoutes: [
                    {
                        title: 'IR Contacts',
                        path: 'ir',
                        name: 'ir',
                        component: IR,
                    },
                    {
                        title: 'Investor Alerts',
                        path: 'investor',
                        name: 'investor',
                        slot: true,
                        exact: false,
                        isMainMenu: true,
                        component: Investor,
                    },
                    {
                        title: 'Unsubscribe',
                        path: 'unsubscribe',
                        name: 'unsubscribe',
                        component: Unsubscribe,
                    },
                    {
                        title: 'Investor FAQ',
                        path: 'faq',
                        name: 'faq',
                        component: FAQ,
                    },
                    {
                        path: '*',
                        redirect: '/contact/ir'
                    }
                ],
            },
            {
                title: 'Html',
                path: 'html/:id',
                name: 'html',
                exact: true,
                component: Html,
            },
            {
                path: '*',
                redirect: '/home'
            }
        ]
    },
];

